import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";

export default class EssenceReferenceLegalEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      pending: false,
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = async () => {
    this.setState({ pending: true });
    const editData = this.props.data;

    this.setState(
      {
        editData,
        pending: false,
      },
      () => this.triggerChange()
    );
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      /*  this.props.onChange({
        definition: this.state.editData.definition || null,
      });*/
    }
  };

  render() {
    const editData = this.state.editData || {};

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="form-group">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Процедура:</label>
                  <input
                    onChange={(e) =>
                      this.onChange("definition", e.target.value)
                    }
                    className="form-control"
                    value={editData.definition || ""}
                  />
                </div>
              </div>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
